import AccordionComponent from "../../entities/AccordionComponents/ui/AccodionComponent";
import Cart from "../../entities/Cart/Cart/Cart";
import styles from './PlanPage.module.scss';
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo';


const PlanPage = () => {
    return ( 
        <div className={styles.plan}>
            <AccordionComponent/>
            <Cart/>
            <FooterInfo/>
        </div>
    );
}

export default PlanPage;